/**
 * Scale Drop Modal – edit, bulk edit & scale a drop, then send immediately.
 * Same 2x2 layout for all modes. For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import { ScaleDropModalBulkEdit } from './modals/ScaleDropModalBulkEdit';
import { ScaleDropModalScaleOrEdit } from './modals/scale-or-edit';
import type { ScaleDropModalProps } from './ScaleDropModal.types';

export const ScaleDropModal: FC<ScaleDropModalProps> = (props) => {
  if (props.mode === 'bulk-edit') {
    return <ScaleDropModalBulkEdit {...props} />;
  }
  return <ScaleDropModalScaleOrEdit {...props} />;
};

export default ScaleDropModal;
